export default __webpack_public_path__ + "static/media/_welcome-bg.4ef20fb8.png";